<template>
  <div>
  <vue-good-table
      :columns="columns"
      :rows="supplierDraftData"
      class="table-word-wrap"
      :pagination-options="{enabled: this.paginationEnabled, ...paginationOptions}"
  >
    <div slot="emptystate">{{ noRecordsMesage }}</div>
    <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'actions'">
                                <div class="content row-content">
                                  <span
                                      class="solution-link"
                                      @click="loadDraftDataInForm(props.row.id)"
                                  >Edit</span> |
                                  <span
                                      class="delete-link"
                                      @click="deleteDraftById(props.row.id)"
                                  >Delete</span>
                                </div>
                            </span>
    </template>
  </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapGetters,mapActions } from "vuex";
import swal from "sweetalert2"
import VGT_PAGINATION_OPTIONS from "../store/vgtPaginationOptions";

export default {
  name: "DraftStatusList",
  components: {VueGoodTable},
  methods: {
    ...mapActions(['deleteDraftRequestById','fetchUserDrafts']),
    loadDraftDataInForm(id) {
      this.$router.push({name: "DraftIntakeForm", params: { id } })
    },
    deleteDraftById(id) {
      swal.fire({
        title: 'Delete draft',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "flat-btn primary-blue-btn btn mb-1",
          cancelButton: "flat-btn gray-btn cancel-btn btn mb-1"
        },
        reverseButtons: true,
        buttonsStyling: false
      }).then((result) => {
        if(result.isConfirmed) {
          swal.showLoading()
          this.deleteDraftRequestById(id).then(() => {
          }).finally(() => {
            this.fetchUserDrafts().then(() => {
              swal.hideLoading()
            })
          })
        }
      })
    }
  },
  data() {
    return {
      paginationOptions: VGT_PAGINATION_OPTIONS.DRAFT_STATUS_LIST_PAGINATION_OPTIONS,
      noRecordsMesage: "No draft records exist."
    }
  },
  computed: {
    ...mapGetters(["supplierDraftData"]),
    paginationEnabled() {
      return this.supplierDraftData.length > 5
    },
    columns() {
      return [
        {
          label: "Product description",
          field: "productDescription",
          type: "string",
          thClass: "width-sm",
          tdClass: "align-left",
          width: "30%"
        },
        {
          label: "Business justification",
          field: "businessJustification",
          type: "string",
          thClass: "width-sm hide-field-xs",
          tdClass: "align-left hide-field-xs",
          width: "30%"
        },
        {
          label: "Date updated",
          type: "string",
          field(rowObj) {
            if(rowObj.updatedOn){
              return rowObj.updatedOn.substring(0,10)
            }
          },
          thClass: "width-sm hide-field-xs",
          tdClass: "hide-field-xs",
          width: "30%"
        },
        {
          label: "Actions",
          field: "actions",
          thClass: "th-actions text-nowrap",
          tdClass: "td-actions text-nowrap",
          width: "10%",
          sortable: false
        }
      ];
    }
  }
}


</script>

<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>

<style scoped>
.delete-icon {
  cursor: pointer;
  height: 30px;
  width: 30px;
}

.edit-icon {
  cursor: pointer;
  height: 23px;
  width: 25px;
}

.delete-link {
  color: red;
  font-weight: bold;
  cursor: pointer;
}
</style>